module.exports = __webpack_public_path__ + "img/Tribunes_Parallax_(Invert).14583cd6.jpeg";